import React from "react";
import "./input.scss";

type HTMLInputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

interface InputProps extends HTMLInputProps {
  errorMessage?: boolean | string;
  successMessage?: boolean | string;
  testId?: string;
  withMessageSpacing?: boolean; // Leave spacing for message to prevent CLS
  wrapperClass?: string;
}

// named to be consistent with the similar component in magento app, toward them being merged.
export const Input: React.FC<InputProps> = (props) => {
  const modifiers: string[] = [];

  if (props.errorMessage) {
    modifiers.push("c-input--error");
  }

  if (props.successMessage) {
    modifiers.push("c-input--success");
  }

  const withErrorMessage = typeof props.errorMessage === "string";
  const withSuccessMessage = typeof props.successMessage === "string";

  const inputProps = { ...props };
  delete inputProps["className"];
  delete inputProps["errorMessage"];
  delete inputProps["testId"];
  delete inputProps["withMessageSpacing"];
  delete inputProps["wrapperClass"];

  return (
    <div className={`c-input ${modifiers.join(" ")} ${props.wrapperClass}`}>
      <input {...inputProps} data-testid={props.testId} className={`c-input__input ${props.className}`} />
      {!withErrorMessage && !withSuccessMessage && props.withMessageSpacing && (
        <div className="c-input__message">&nbsp;</div>
      )}

      {withErrorMessage && (
        <div data-testid="input-error" className="c-input__message c-input__error">
          {props.errorMessage}
        </div>
      )}

      {withSuccessMessage && (
        <div data-testid="input-success" className="c-input__message c-input__success">
          {props.successMessage}
        </div>
      )}
    </div>
  );
};
